import { render, staticRenderFns } from "./StudentVideoList.vue?vue&type=template&id=26b6c9ec&scoped=true&"
import script from "./StudentVideoList.vue?vue&type=script&lang=js&"
export * from "./StudentVideoList.vue?vue&type=script&lang=js&"
import style0 from "./StudentVideoList.vue?vue&type=style&index=0&id=26b6c9ec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b6c9ec",
  null
  
)

export default component.exports